<main>
  <GoogleAnalytics properties={[ 'G-C85WBNSL7Z' ]} />
  {#if initialised}
    {#if !dbConnectionFailure}
    <Router />
    {:else}
    <Disconnected />
    {/if}
  {/if}
</main>

<script lang="ts">
  import { appState } from "./lib/appState.js";
  import "./styles/main.scss";
  import { GoogleAnalytics } from '@beyonk/svelte-google-analytics';
  import Router from "./Router.svelte";
  import Disconnected from './pages/_components/Disconnected.svelte';
  import { logging } from './lib/logging.js';

  import firebase from "firebase/app";
  import "firebase/firestore";
  import "firebase/auth";
  import "firebase/performance";
  import "firebase/analytics";
  import "firebase/functions";
  import "firebase/storage";
  import { init } from "svelte/internal";

  let initialised = false;
  let dbConnectionFailure = false;

  fetch("/__/firebase/init.json")
  .then(async (response) => {
    const firebaseInitParams = await response.json();
    firebase.initializeApp(firebaseInitParams);
    firebase.firestore().settings({ignoreUndefinedProperties:true});

    logging.start({
        key: firebaseInitParams.apiKey,
        projectId: firebaseInitParams.projectId,
    });

    initialised = true;
  })
  .then(() => {
    firebase.firestore().doc('_config/test').get()
    .then(() => {
      // no action
    })
    .catch((err) => {
      dbConnectionFailure = true;
      logging.report('No connection to firestore');
    });
  });


  window.firebase = firebase;

  $appState.origin = window.location.origin;
</script>
